import React, { forwardRef } from 'react';

export const DEFAULT_COLOR = '#FFFFFF';

const OfferCardTag = forwardRef(function OfferCardTag({ color, ...rest }, ref) {
  return (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...rest}>
      <g filter="url(#filter0_d)">
        <path d="M20 12L11.68 7L4 12V2H20V12Z" fill={color || DEFAULT_COLOR} />
      </g>
      <defs>
        <filter id="filter0_d" x="0" y="0" width="24" height="18" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="2"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>
  );
});

export default OfferCardTag;
